import FormattedMessage from 'I18n/components/FormattedMessage';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { CAMPAIGN_TYPE_ID, CONTACT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { useAssociatedObjectsCardRedesignContext } from '../context/AssociatedObjectsCardRedesignContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function CardTitle() {
  const {
    title,
    total,
    toObjectTypeId,
    fromObjectTypeId
  } = useAssociatedObjectsCardRedesignContext();
  const displayBetaBadge = toObjectTypeId === CAMPAIGN_TYPE_ID && fromObjectTypeId === CONTACT_TYPE_ID;
  return /*#__PURE__*/_jsxs("span", {
    children: [total !== undefined ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "cardAssociatedObjects.title.GENERIC.exact",
      options: {
        count: total,
        label: title
      }
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: title !== null && title !== void 0 ? title : ''
    }), displayBetaBadge && /*#__PURE__*/_jsx(Badge, {
      use: "beta",
      marginInlineStart: "200",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "cardAssociatedObjects.title.GENERIC.beta"
      })
    })]
  });
}
export default CardTitle;